import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepForPasswordComponent } from '../cadastro/step-for-password/step-for-password.component';
import { StepThreeTokenComponent } from '../cadastro/step-three-token/step-three-token.component';
import { StepTwoAuthComponent } from '../cadastro/step-two-auth/step-two-auth.component';
import { LoginComponent } from './login.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path:'confirmacao', component:StepThreeTokenComponent, data : { title:'Falta Pouco!'}
  },
  {
    path:'senha', component:StepForPasswordComponent,  data : { title:'Para finalizar, crie uma nova senha', textBtn: 'Atualizar e voltar para login'}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
